import {
  Component,
  Input,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import {
  NbDialogRef,
  NbDialogService,
  NbWindowRef,
  NbWindowService,
} from "@nebular/theme";
import * as _ from "lodash";
import { LocalDataSource } from "ng2-smart-table";
import { Subject } from "rxjs";
import { map, takeUntil } from "rxjs/operators";
import { User } from "../../../@core/data/users";
import { UserService } from "../../../@core/services/user.service";
import { ExcelService } from "../../../@core/utils/excel.service";
import Announcement from "../../../models/announcement.model";
import { AnnouncementService } from "../../../services/announcement.service";
import { DialogYesNoPromptComponent } from "../../dialog-yesno-prompt/dialog-yesno-prompt.component";
import { DialogAnnouncementComponent } from "../../dialogs/dialog-announcement/dialog-announcement.component";
import { StbCustomRenderStatusEditorComponent } from "../../smart-table-customs/custom-render-status-editor";

@Component({
  selector: "ngx-window-guide",
  templateUrl: "window-guide.component.html",
  styleUrls: ["window-guide.component.scss"],
})
export class WindowGuideComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();

  shopId = "";
  uid = "";
  user: User;
  loading: boolean = false;
  submitted: boolean = false;
  strSearch: string = "";
  announcements?: Announcement[] = [];
  display?: Announcement[] = [];
  guide: Announcement = new Announcement();
  showDetail: boolean = false;
  editorGuide: boolean = false;
  importing: boolean = false;
  importAnnouncement?: Announcement[] = [];

  //ng2-smart-table config
  @Input() source: LocalDataSource = new LocalDataSource();
  // settings: any;
  settings = {
    hideHeader: false,
    noDataMessage: "",
    attr: {
      class: "table table-striped",
    },
    actions: {
      columnTitle: "",
      add: false,
      edit: false,
      delete: true,
    },
    add: {
      confirmCreate: true,
      addButtonContent: '<i class="nb-plus"></i>',
      createButtonContent: '<i class="nb-checkmark"></i>',
      cancelButtonContent: '<i class="nb-close"></i>',
    },
    edit: {
      confirmSave: true,
      editButtonContent: '<i class="nb-edit"></i>',
      saveButtonContent: '<i class="nb-checkmark"></i>',
      cancelButtonContent: '<i class="nb-close"></i>',
    },
    delete: {
      confirmDelete: true,
      deleteButtonContent: '<i class="nb-trash"></i>',
    },
    columns: {
      title: {
        title: "Chức năng",
        type: "string",
      },
      description: {
        title: "Mô tả",
        type: "string",
      },
      status: {
        title: "Trạng thái",
        type: "custom",
        renderComponent: StbCustomRenderStatusEditorComponent,
        filter: {
          type: "list",
          config: {
            selectText: "Chọn...",
            list: [
              {
                value: "0",
                title: "Đang thực hiện",
              },
              {
                value: "1",
                title: "Xuất bản",
              },
              {
                value: "-1",
                title: "Ẩn nội dung",
              },
            ],
          },
        },
      },
    },
  };

  constructor(
    protected windowRef: NbWindowRef,
    public userService: UserService,
    private announcementService: AnnouncementService,
    private excelSrv: ExcelService,
    private dialogService: NbDialogService
  ) {}

  ngOnInit() {
    this.userService
      .getCurrentUser()
      .pipe(takeUntil(this.destroy$))
      .subscribe((user: User) => {
        if (user && user.uid != this.uid) {
          this.uid = user.uid;
          this.user = user;
          this.shopId = user.shopId;

          if (user.admin) {
            this.editorGuide = true;
            this.getEditorGuides();
          } else {
            this.getGuides();
          }
        } else {
          this.uid = "anonymous";
        }
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onSearch(): void {
    if (this.strSearch) {
      this.strSearch = this.strSearch.toLowerCase();
      this.display = this.announcements.filter(
        function (item) {
          return (
            item.title.toLowerCase().includes(this.strSearch) ||
            item.description.toLowerCase().includes(this.strSearch)
          );
        },
        { strSearch: this.strSearch }
      );
    } else {
      this.display = [...this.announcements];
    }

    this.source.load(this.display);
  }

  clearSearch() {
    this.strSearch = "";
    this.onSearch();
  }

  onNew() {
    this.importing = false;

    let fbNew = new Announcement();
    fbNew.priority = "info";
    fbNew.category = "guide";

    this.dialogService
      .open(DialogAnnouncementComponent, {
        context: {
          header: "Tạo hướng dẫn",
          mode: "new",
          user: this.user,
          announcement: fbNew,
        },
        closeOnBackdropClick: false,
      })
      .onClose.subscribe((value) => {
        if (value && value.status == 1) {
          this.announcements = [value, ...this.announcements];
        }
      });
  }

  onEdit(item: Announcement) {
    let lecBk = new Announcement();
    lecBk = _.clone(item);
    this.dialogService
      .open(DialogAnnouncementComponent, {
        context: {
          header: "Cập nhật bài viết",
          mode: "edit",
          user: this.user,
          announcement: lecBk,
        },
        closeOnBackdropClick: false,
      })
      .onClose.subscribe((value) => {
        if (value) {
          item = value;
          this.guide = value;
        }
      });
  }

  onDelete(item) {
    this.dialogService
      .open(DialogYesNoPromptComponent, {
        context: {
          title: "Bạn có chắc xóa nội dung này?",
        },
      })
      .onClose.subscribe((value) => {
        if (value) {
          this.announcementService
            .delete(item.id)
            .then((result) => {
              this.loading = false;
              this.submitted = false;
              this.closeDetail();
            })
            .catch((err) => {
              this.loading = false;
              this.submitted = false;
            });
        }
      });
  }

  //smart-table events
  selectedItem(event): void {
    let item = event.data;
    this.showDetail = true;
    this.guide = _.clone(item);
  }

  viewDetail(item: Announcement) {
    this.showDetail = true;
    this.guide = _.clone(item);
  }

  closeDetail() {
    this.showDetail = false;
  }

  onDeleteConfirm(event): void {
    console.log("onDeleteConfirm:", event);
    const id = event.data.id;
    this.dialogService
      .open(DialogYesNoPromptComponent, {
        context: {
          title: "Bạn có chắc xóa nội dung này?",
        },
      })
      .onClose.subscribe((value) => {
        if (value) {
          this.announcementService
            .delete(id)
            .then((result) => {
              this.loading = false;
              this.submitted = false;
              event.confirm.resolve();
            })
            .catch((err) => {
              this.loading = false;
              this.submitted = false;
              event.confirm.reject();
            });
        } else {
          event.confirm.reject();
        }
      });
  }

  //import

  //File Product
  onFileChange(evt: any) {
    this.importing = true;
    this.display = [];
    this.importAnnouncement = [];

    const target: DataTransfer = <DataTransfer>evt.target;
    if (target.files.length !== 1) throw new Error("Cannot use multiple files");

    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      const bstr: string = e.target.result;
      const data = <any[]>this.excelSrv.importFromFile(bstr);

      // const header: string[] = Object.getOwnPropertyNames(new Product());
      const header: string[] = [
        "category",
        "title",
        "description",
        "sourceType",
        "status",
        "content",
        "imagesUrl",
        "priority",
      ];
      // let importedData = data.slice(1); //remove header data
      const importedData = _.filter(data, (el, index) => {
        return index > 0 && el && el.length > 0 && el[3];
      });

      this.importAnnouncement = importedData.map((arr) => {
        const obj: Announcement = {};
        for (let i = 0; i < header.length; i++) {
          const k = header[i];
          obj[k] = arr[i];
        }

        this.display.push(obj);
        return <Announcement>obj;
      });
    };
    reader.readAsBinaryString(target.files[0]);
  }

  downloadTemplate(fileName: string) {
    const expData: any[] = [
      {
        category: "",
        title: "",
        description: "",
        sourceType: "",
        status: 1,
        content: "",
        imagesUrl: "",
        priority: "",
      },
    ];

    this.excelSrv.exportAsExcelFile(expData, fileName);
  }

  uploadAnnouncement() {
    const uploadData = _.clone(this.importAnnouncement);

    _.forEach(uploadData, (item, i) => {
      this.loading = true;

      this.announcementService
        .create(item)
        .then((data) => {
          const index = this.importAnnouncement.indexOf(item);
          if (index > -1) this.importAnnouncement.splice(index, 1);

          this.loading = false;
        })
        .catch((err) => {
          console.log(err);

          this.loading = false;
        });
    });

    this.importing = false;
  }

  //
  private getGuides(): void {
    this.loading = true;

    this.announcementService
      .getGuides()
      // .snapshotChanges(["added", "removed"])
      .snapshotChanges()
      .pipe(
        map((changes) =>
          changes.map((c) => ({
            id: c.payload.doc.id,
            ...c.payload.doc.data(),
          }))
        ),
        takeUntil(this.destroy$)
      )
      .subscribe((data) => {
        this.announcements = data;
        console.log("getGuides", this.announcements);

        this.onSearch();

        this.loading = false;
      });
  }

  private getEditorGuides(): void {
    this.loading = true;

    this.announcementService
      .getCrudGuides()
      // .snapshotChanges(["added", "removed"])
      .snapshotChanges()
      .pipe(
        map((changes) =>
          changes.map((c) => ({
            id: c.payload.doc.id,
            ...c.payload.doc.data(),
          }))
        ),
        takeUntil(this.destroy$)
      )
      .subscribe((data) => {
        this.announcements = data;
        console.log("getGuides", this.announcements);

        this.onSearch();

        this.loading = false;
      });
  }

  minimize() {
    this.windowRef.minimize();
  }

  close() {
    this.windowRef.close();
  }
}
